import { styled, Typography } from '@mui/material';
import { type FC } from 'react';
import { useToggle } from '../../../../../../../../hooks/use-toggle';
import { ControlledTextInput } from '../../../../components/ControlledTextInput';
import { ConfigurationSection } from '../../../../containers/ConfigurationSection';
import type {
  PaddleConfigurationControl,
  PaddleConfigurationFormValues,
} from '../../PaddleConfigurationFormSchema';

interface Props {
  defaultValues: PaddleConfigurationFormValues;
  control: PaddleConfigurationControl;
}

export const KeyConfigurationSection: FC<Props> = ({ control, defaultValues }) => {
  const [disabled, toggleDisabled] = useToggle(true);

  return (
    <ConfigurationSection title="Paddle Key" iconName="Key">
      <TextInputContainer>
        <TextInputHeaderContainer>
          <Typography
            sx={{
              fontSize: '12px',
              fontStyle: 'normal',
              fontWeight: 400,
              lineHeight: '12px',
              opacity: disabled ? 0.6 : 1,
            }}
          >
            API Key
          </Typography>
          <Typography
            sx={{
              color: '#3A78F8',
              fontSize: '12px',
              fontStyle: 'normal',
              fontWeight: 400,
              lineHeight: '12px',
              cursor: 'pointer',
            }}
            onClick={() => toggleDisabled()}
          >
            Modify
          </Typography>
        </TextInputHeaderContainer>
        <ControlledTextInput
          name="apiToken"
          control={control}
          disabled={disabled}
          placeholder="Enter API Key here..."
          defaultValue={defaultValues.apiToken}
        />
      </TextInputContainer>
    </ConfigurationSection>
  );
};

const TextInputContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
});

const TextInputHeaderContainer = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
});
